import { getBearerToken } from "./authService";

export async function request(url, options = {}, timeout) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, timeout);

  const headers = {
    "Content-Type": "application/json",
  };

  let token;
  try {
    token = await getBearerToken();
  } catch (error) {
    console.error("Error fetching bearer token:", error);
  }
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const defaults = {
    headers,
    signal: controller.signal,
  };

  let response;
  try {
    response = await fetch(url, { ...defaults, ...options });
    clearTimeout(timeoutId);
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === "AbortError") {
      throw new Error("Timeout Expired");
    }
    throw error;
  }

  if (!response.ok) {
    const errorData = await response.json();
    let errorMessage = "Ooops, something went wrong";
    if (errorData.detail) {
      if (Array.isArray(errorData.detail)) {
        errorMessage += "\n\n" + response.status + " - " + errorData.detail.map(item => item.msg || JSON.stringify(item)).join("\n");
      } else {
        errorMessage += "\n\n" + response.status + " - " + errorData.detail;
      }
    }
    throw new Error(errorMessage);
  }

  return response.json();
}